// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as Core__Array from "@rescript/core/src/Core__Array.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";

let invalidCNPJs = [
  "00000000000000",
  "11111111111111",
  "22222222222222",
  "33333333333333",
  "44444444444444",
  "55555555555555",
  "66666666666666",
  "77777777777777",
  "88888888888888",
  "99999999999999"
];

function isNumeric(str) {
  return /^\d*$/.test(str);
}

function isUppercaseAlphanumeric(str) {
  return /^[A-Z0-9]*$/.test(str);
}

function isCNPJValidFormat(cnpj) {
  let base = cnpj.slice(0, 12);
  let checkDigits = cnpj.slice(12, 14);
  if (isUppercaseAlphanumeric(base)) {
    return isNumeric(checkDigits);
  } else {
    return false;
  }
}

function charToValue(ch) {
  let code = ch.charCodeAt(0) | 0;
  if (code >= 48 && code <= 57 || code >= 65 && code <= 90) {
    return code - 48 | 0;
  } else {
    return 0;
  }
}

function calculateCheckDigit(values, weights) {
  let sum = Core__Array.reduceWithIndex(values, 0, (acc, v, i) => acc + (v * Core__Option.getOr(weights[i], 0) | 0) | 0);
  let remainder = sum % 11;
  if (remainder < 2) {
    return 0;
  } else {
    return 11 - remainder | 0;
  }
}

function validateCNPJ(cnpj) {
  let chars = cnpj.split("");
  let base = chars.slice(0, 12).map(charToValue);
  let firstDigit = calculateCheckDigit(base, [
    5,
    4,
    3,
    2,
    9,
    8,
    7,
    6,
    5,
    4,
    3,
    2
  ]);
  let secondDigit = calculateCheckDigit(Belt_Array.concatMany([
    base,
    [firstDigit]
  ]), [
    6,
    5,
    4,
    3,
    2,
    9,
    8,
    7,
    6,
    5,
    4,
    3,
    2
  ]);
  let checkDigit1 = Core__Option.getOr(Core__Option.map(chars[12], charToValue), -1);
  let checkDigit2 = Core__Option.getOr(Core__Option.map(chars[13], charToValue), -1);
  if (firstDigit === checkDigit1) {
    return secondDigit === checkDigit2;
  } else {
    return false;
  }
}

function isValidCNPJ(cnpj) {
  if (cnpj.length !== 14 || invalidCNPJs.includes(cnpj) || !isCNPJValidFormat(cnpj)) {
    return false;
  } else {
    return validateCNPJ(cnpj);
  }
}

let cnpjLength = 14;

export {
  cnpjLength,
  invalidCNPJs,
  isNumeric,
  isUppercaseAlphanumeric,
  isCNPJValidFormat,
  charToValue,
  calculateCheckDigit,
  validateCNPJ,
  isValidCNPJ,
}
/* No side effect */
